export class Claims {
    init() {
        var self = {
            selectors: {
                productLoader: "#productLoader",
                claimsPage: "#claimsPage",
                claimsSection: "#claimsSection",
                sortBtn: ".claims__sort",
                sortAsc: "asc",
                sortAscClassName: "claims__sort--asc",
                sortDesc: "desc",
                sortDescClassName: "claims__sort--desc",
                filterInput: ".claim-filter",
                filters: [
                    "product",
                    "date",
                    "action",
                    "shares",
                    "status"
                ],
            },
            loadData: function () {
                $(self.selectors.claimsSection).hide();
                $(self.selectors.productLoader).show()

                var $section = $(self.selectors.claimsPage);
                var url = $section.attr('data-url');
                var searchParams = new URLSearchParams(window.location.search)

                // Get Current Ordering
                var currentOrdering = searchParams.get("ordering");
                currentOrdering = currentOrdering !== null && currentOrdering.length > 0 ? currentOrdering : '-date';

                // Get Current Page
                var currentPage = searchParams.get("page");
                currentPage = currentPage !== null && currentPage > 0 ? currentPage : 1;

                // Get Filters Data
                var $filtersData = {};

                $.each(self.selectors.filters, (index, filter) => {
                    var paramValue = searchParams.get(filter);
                    $filtersData[filter] = paramValue !== null && paramValue.length > 0 ? paramValue : null;
                });

                $.ajax({
                    url: url,
                    type: 'GET',
                    data: {
                        ordering: currentOrdering,
                        page: currentPage,
                        filters: $filtersData
                    },
                    success: function (res) {
                        $(self.selectors.claimsSection).show().html(res.html);
                        self.paginate();
                    },
                    complete: function () {
                        $(self.selectors.productLoader).hide();
                    }
                });
            },
            setUrlSortQueryParam: function (ordering = null, page = null) {
                // Set query param in URL
                var searchParams = new URLSearchParams(window.location.search)

                if (ordering !== null) {
                    searchParams.set("ordering", ordering);
                }

                if (page !== null) {
                    searchParams.set("page", page);
                }

                self.setQueryParamsAndReload(searchParams.toString())
            },
            toggleActiveClass: function ($this) {
                $(self.selectors.sortBtn).removeClass('active');
                $this.addClass('active');
            },
            toggleOrdering: function ($this) {
                var currentSort = $this.attr('data-sort');
                self.setDefaultParams();

                if (!$this.hasClass('active')) {
                    return;
                }

                if (currentSort === self.selectors.sortAsc) {
                    $this.removeClass(self.selectors.sortAscClassName).addClass(self.selectors.sortDescClassName)
                    $this.attr('data-ordering', '-' + $this.attr('data-ordering'));
                    $this.attr('data-sort', self.selectors.sortDesc);
                } else {
                    $this.removeClass(self.selectors.sortDescClassName).addClass(self.selectors.sortAscClassName)
                    $this.attr('data-ordering', $this.attr('data-base-ordering'));
                    $this.attr('data-sort', self.selectors.sortAsc);
                }
            },
            toggleClearFiltersBtn(isHidden) {
                isHidden ? $('.claims-filters__clear').addClass('d-none') : $('.claims-filters__clear').removeClass('d-none');
            },
            setDefaultParams() {
                $(self.selectors.sortBtn).removeClass(self.selectors.sortDescClassName).addClass(self.selectors.sortAscClassName);
                $(self.selectors.sortBtn).attr('data-sort', self.selectors.sortAsc);

                $(self.selectors.sortBtn).each(function () {
                    var baseValue = $(this).attr('data-base-ordering');
                    $(this).attr('data-ordering', baseValue);
                });
            },
            paginate() {
                $(".claims__pagination a").on('click', function (e) {
                    e.preventDefault();

                    var url = new URL($(this).attr('href'));
                    var ordering = url.searchParams.get('ordering');
                    var page = url.searchParams.get('page', 1);

                    $('html, body').animate({
                        scrollTop: $('.profile-heading').offset().top
                    }, 500);

                    self.setUrlSortQueryParam(ordering, page);
                });
            },
            changeFilters(filtersValues) {
                var searchParams = new URLSearchParams(window.location.search)
                searchParams.delete('page');

                $.each(filtersValues, function (index, filter) {
                    searchParams.set(filter.name, filter.value);
                });

                self.setQueryParamsAndReload(searchParams.toString())
            },
            clearQueryFilters() {
                var searchParams = new URLSearchParams(window.location.search)

                $.each(self.selectors.filters, (index, filter) => {
                    searchParams.delete(filter);
                });

                self.setQueryParamsAndReload(searchParams.toString())
            },
            setQueryParamsAndReload(params) {
                // Save new URL in browser history without page reload
                var newRelativePathQuery = window.location.pathname + '?' + params;
                history.pushState(null, '', newRelativePathQuery);
                self.loadData();
            },
            setValuesInFilterFormOnLoad() {
                var areFiltersEmpty = true;
                var searchParams = new URLSearchParams(window.location.search)

                $.each(self.selectors.filters, (index, filter) => {
                    var filterValue = searchParams.get(filter);

                    if (filterValue !== null && filterValue.length > 0) {
                        $('[name="' + filter + '"]').val(filterValue);
                        areFiltersEmpty = false;
                    }
                });

                self.toggleClearFiltersBtn(areFiltersEmpty);
            },
            filter() {
                var empty = true;
                var valuesArr = [];

                $('.claims-filters__form input, .claims-filters__form select').each((index, item) => {
                    var $value = $(item).val();

                    // Check filters have values
                    if ($value != '' || $value == null) {
                        empty = false;
                    }

                    valuesArr.push({
                        value: $value,
                        name: $(item).attr("name")
                    });
                });

                self.changeFilters(valuesArr);
                self.toggleClearFiltersBtn(empty);
            }
        };

        if ($.fn.datepicker) {
            $('.datepicker-claim-date').datepicker({
                format: 'yyyy-mm-dd',
                autoclose: true,
            }).on('changeDate', function (e) {
                self.filter();
            });

            $('.datepicker-claim-date').trigger('changeDate');

            $('.input-datapicker img').click(function () {
                var $datapicker = $(this).closest('.input-datapicker').find('.datepicker');
                if ($datapicker.hasClass('active')) {
                    $datapicker.removeClass('active');
                } else {
                    $datapicker.addClass('active');
                    $datapicker.datepicker("show");
                }
            });
        }

        $(self.selectors.sortBtn).click(function () {
            self.toggleOrdering($(this))
            self.toggleActiveClass($(this))
            self.setUrlSortQueryParam($(this).attr('data-ordering'))
        });

        if ($(self.selectors.claimsPage).length > 0 && typeof $(self.selectors.claimsPage) !== 'undefined') {
            self.loadData()
            self.setValuesInFilterFormOnLoad()
        }

        $(".claims-filters__btn").on('click', function (e) {
            e.preventDefault();
            var form = $('.claims-filters__form');

            if (form.hasClass('d-none')) {
                form.removeClass('d-none');
                $(this).removeClass('closed');
            } else {
                form.addClass('d-none')
                $(this).addClass('closed');
            }
        });

        $(".claims-filters__form input, .claims-filters__form select").on("input", function () {
            self.filter();
        });

        $(".claims-filters__clear").on('click', function (e) {
            e.preventDefault();
            self.clearQueryFilters();

            $('input, select').each(function () {
                $(this).val('');
            });

            $(this).addClass('d-none');
        });

        $("body").on("addNewClaim", function () {
            self.loadData();
        });
    }
}